var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgAngleDowntime = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 367,
  height: 441,
  fill: "none",
  viewBox: "0 0 367 441"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#53565B",
  fillOpacity: 0.2,
  d: "M6 0H0v441h6V0ZM367 441v-6H6v6h361Z"
})));
export { SvgAngleDowntime as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzY3IiBoZWlnaHQ9IjQ0MSIgdmlld0JveD0iMCAwIDM2NyA0NDEiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGQ9Ik02IDBMMC4wMDAyMjk4MDEgNC4zNzEwNGUtMDdMMCA0NDFINS45OTk3NUw2IDBaIiBmaWxsPSIjNTM1NjVCIiBmaWxsLW9wYWNpdHk9IjAuMiIvPgo8cGF0aCBkPSJNMzY3IDQ0MVY0MzVMNiA0MzVMNS45OTk3NSA0NDFIMzY3WiIgZmlsbD0iIzUzNTY1QiIgZmlsbC1vcGFjaXR5PSIwLjIiLz4KPC9zdmc+Cg==";